import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import Modal from 'react-responsive-modal'
import { Preloader } from 'SRC/ui/Preloader'
import { Notification } from 'react-notification'
import { fetchAgents, setAgentsLoading } from 'SRC/modules/users/Profile/actions'
import { getAgents, getAgentsLoading } from 'SRC/modules/users/Profile/selectors'
import { ProfileApi } from 'SRC/modules/users/Profile/api'
import { AgentItem } from '../Item'

class List extends React.Component {
  constructor (props) {
    super(props)

    this.cookie = new CookiesHelper()
    this.api = new ProfileApi()

    const { fetchAgents } = props

    const userId = this.cookie.get('userId')
    const token = this.cookie.get('token')

    if (userId && token) {
      fetchAgents(userId, token)
    }

    this.state = {
      showDeleteModal: false,
      deleteAgentId: null,
      deleteAgentNotification: ''
    }
  }

  openDeleteModal = agentId => {
    this.setState({ showDeleteModal: true, deleteAgentId: agentId })
  }

  removeAgent = async () => {
    const { setAgentsLoading, fetchAgents } = this.props
    const { deleteAgentId } = this.state

    const userId = this.cookie.get('userId')
    const token = this.cookie.get('token')

    const params = {
      userId,
      token,
      agent: deleteAgentId
    }

    this.closeModal()
    setAgentsLoading(true)

    const result = await this.api.removeAgent(params)
    console.log('result', result)

    if (result && result.status === 'ok') {
      this.setState({ deleteAgentNotification: 'Agent je uspješno obrisan.' })

      setTimeout(() => {
        fetchAgents(userId, token)
      }, 500)
    } else {
      this.setState({ deleteAgentNotification: 'Greška. Agent nije obrisan.' })
      setAgentsLoading(false)
    }
  }

  renderList = () => {
    const { agents, isAgentsLoading, setAgent } = this.props

    if (isAgentsLoading) return <Preloader />

    if (!Array.isArray(agents) || !agents.length) {
      return <p className='no-agents'>Nemate agenata</p>
    } else {
      return agents.map(agent => (
        <AgentItem
          key={`agent-item-${agent.id}`}
          id={agent.id}
          name={agent.name}
          phone={agent.phone}
          email={agent.email}
          image={agent.image}
          onRemoveClick={this.openDeleteModal}
          onEditClick={() => { setAgent(agent) }}
        />
      ))
    }
  }

  closeModal = () => {
    this.setState({ showDeleteModal: false, deleteAgentId: null })
  }

  hideNotification = () => {
    this.setState({ deleteAgentNotification: '' })
  }

  renderDeleteModal = () => {
    const { showDeleteModal } = this.state

    return (
      <Modal
        open={showDeleteModal}
        onClose={this.closeModal}
        center
        closeOnEsc
        closeOnOverlayClick
        showCloseIcon
        onExited={this.closeModal}
        classNames={{ modal: 'agents-delete-modal' }}
      >
        <div>
          <p>Da li ste sigurni da želite da obrišete agenta?</p>

          <button className='agents-delete-modal__action' onClick={this.removeAgent}>Da</button>
          <button className='agents-delete-modal__action' onClick={this.closeModal}>Ne</button>
        </div>
      </Modal>
    )
  }

  render () {
    const { deleteAgentNotification } = this.state

    return (
      <section className='agents-content'>
        {this.renderList()}
        {this.renderDeleteModal()}

        <Notification isActive={Boolean(deleteAgentNotification)} message={deleteAgentNotification || ``}
          action={'Sakrij'} onClick={this.hideNotification}
        />
      </section>
    )
  }
}

const mapStateToProps = state => ({
  agents: getAgents(state),
  isAgentsLoading: getAgentsLoading(state)
})

List.propTypes = {
  agents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  })).isRequired,
  isAgentsLoading: PropTypes.bool.isRequired,
  fetchAgents: PropTypes.func.isRequired,
  setAgentsLoading: PropTypes.func.isRequired,
  setAgent: PropTypes.func.isRequired
}

List.displayName = 'AgentsList'

export default connect(mapStateToProps, { fetchAgents, setAgentsLoading })(List)
